import React from 'react';
import { HeroSection } from './components/HeroSection';
import { WhatIsSection } from './components/WhatIsSection';
import { ProblemSection } from './components/ProblemSection';
import { AudienceSection } from './components/AudienceSection';
import { BenefitsSection } from './components/BenefitsSection';
import { ContentsSection } from './components/ContentsSection';
import { ModulesSection } from './components/ModulesSection';
import { PricingCTA } from './components/PricingCTA';
import { Footer } from './components/Footer';
export function App() {
  return <div className="w-full min-h-screen font-body" data-id="element-0">
      <HeroSection data-id="element-1" />
      <WhatIsSection data-id="element-2" />
      <ProblemSection data-id="element-3" />
      <AudienceSection data-id="element-4" />
      <BenefitsSection data-id="element-5" />
      <ContentsSection data-id="element-6" />
      <ModulesSection data-id="element-7" />
      <PricingCTA data-id="element-8" />
      <Footer data-id="element-9" />
    </div>;
}